//en.js
const en = {
  //公共
  common: {
    notSupport: 'Your browser does not support full screen mode',
    loadFail: 'Theme loading failed',
    noPermission: 'Sorry, you do not have permission to access that page',
    backHome: 'Return to homepage',
    noExit: 'The page you are trying to access does not exist',
    serverError: 'Sorry, the server has encountered an error',
    slide: 'Swipe right',
    veryHigh: 'Very High',
    high: 'High',
    target: 'Target',
    urgentLow: 'Very Low',
    agpNoData: 'AGP report requires at least 5 days of data to generate',
    noDataStr: 'No Data',
    setting: 'Setting',
    personInfo: 'Basic Information',
    updatePwd: 'Change Password',
    upHead: 'Upload Pictures',
    inRange: 'In Range',
    normal: 'Normal',
    low: 'Low',
    previous: 'Previous',
    next: 'Next',
    search: 'Search',
    reset: 'Reset',
    cancel: 'Cancel',
    ok: 'Ok',
    confirm: 'Confirm',
    save: 'Save',
    submit: 'Submit',
    successful: 'Successful',
    pleaseEnter: 'Please enter',
    pleaseSelect: 'Please select',
    success: 'Success',
    confirmLogout: 'Are you sure you want to log out?',
    updateSuccessed: 'Update succussed',
    warning: 'Warning',
    date: 'Date',
    start: 'Start',
    end: 'End',
    sevenDays: '7 Days',
    fourteenDays: '14 Days',
    thirtyDays: '30 Days',
    signOut: 'Sign Out',
    personalInformation: 'Personal Information',
    email: 'Email',
    name: 'Name',
    mobile: 'Mobile',
    dateOfBirth: 'D.O.B',
    gender: 'Gender',
    diabeteType: 'Type of  Diabetes',
    dateOfDignose: 'Year of diagnose',
    remarks: 'Remarks',
    optionMale: 'Male',
    optionFemale: 'Female',
    optionUnknow: 'Prefer Not to State',
    noDiabetes: 'No Diabetes',
    diabeteTypeI: 'Type I',
    diabeteTypeII: 'Type II',
    diabeteSpecial: 'Special',
    diabeteGestational: 'Gestational Diabetes',
    diabeteOthers: 'Others',
    ruleMsgEmail: 'Please enter email',
    ruleMsgName: 'Please enter name',
    ruleMsgMobile: 'Please enter mobile',
    ruleMsgBirthday: 'Please select birthday',
    ruleMsgSex: 'Please select gender',
    ruleMsgDiabeteType: 'Please select diabetes Type',
    ruleMsgDateOfDignose: 'Please select year of diagnose',
    ruleMsgRemarks: 'Please enter remarks',
    ruleMsgCorrectMobile: 'Please enter the correct mobile',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    ruleMsgOldPassword: 'Please enter old password',
    ruleMsgNewPassword: 'Please enter new password',
    ruleMsgConfirmPassword: 'Please confirm password',
    passwordInconsistent: 'The two password inputs are inconsistent',
    passwordModifySuccessed:
      'Your password has been reset, please login again!',
    monday: 'Mon',
    tuesday: 'Tues',
    wednesday: 'Wed',
    thursday: 'Thur',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun',
    sn: 'SN',
    startDate: 'Start Date',
    days: 'days',
    pdfDate: 'Goal',
    close: 'close',
    // inputTip: 'Please enter keywords to search',
    inputTip: 'Please enter keywords to s...',
    polarization: 'Device Initializing',
    hour: 'h',
    minutes: 'min',
    seconds: 's',
    reportDownLoadTip: 'Your report has not been generated for 5 days.',
    age: 'age',
    goal: 'Goal',
    expired: 'sensor Expired',
    lastTime: 'Last Refreshed Time',
    timeZone: 'Time zone'
  },
  //路由
  route: {
    login: 'Login',
    forget: 'Forget Password',
    home: 'Home',
    glucoseReport: 'Glucose Report',
    sessionReport: 'Session Report',
    eventList: 'Event List',
    followerList: 'Follower List',
    followerListQ: 'Observer Request',
    settings: 'Settings',
    profile: 'Profile'
  },
  //登录
  login: {
    rememberMe: 'Remember me',
    forgetPassword: 'Forget password',
    agree: 'Login means agree to FurCarer',
    privacyPolicy: 'Privacy policy',
    CGMUser: 'CGM User',
    follower: 'Follower',
    ruleMsgPassword: 'Please enter password',
    login: 'Login',
    phonePlacehold: 'Please enter phone number',
    codePlacehold: 'Please enter the verification code',
    codePlaceholdInput: 'Please enter t...',
    phoneTip: 'By Phone',
    emialTip: 'By Email',
    codeTip: 'Get verification code',
    reGetTip: 'Re-acquisition'
  },
  layout: {
    collapseUp: 'Hide Menu',
    collapseDown: 'Expand Menu',
    refresh: 'Refresh',
    backHome: 'Home',
    helpCenter: 'Help Center',
    fullScreen: 'Full Screen'
  },
  //忘记密码
  forget: {
    ruleMsgCode: 'Please enter code',
    sendCode: 'Send Code',
    tipsMsgSendSuccess: 'The verification code was successfully sent!',
    tipsMsgModifySuccess: 'Password modification successful'
  },
  //首页
  home: {
    title: 'FurCarer Portal',
    todaysGlucose: 'Glucose Today ',
    todaysOverview: 'Overview Today',
    maxGlucose: 'Max. Glucose',
    minGlucose: 'Min. Glucose',
    avgGlucose: 'Avg. Glucose',
    maxmumVariation: 'Maximum Variation',
    glucose: 'Glucose',
    tir: 'TIR',
    latestGlucose: 'Latest Glucose',
    todayPercentage: '% of Today in different range',
    fourHour: '4 Hour',
    eightHour: '8 Hour',
    twelveHour: '12 Hour',
    twentyFourHour: '24 Hour',
    glucoseOnly: 'Glucose Only',
    sessionOverview: 'Session Overview',
    glocuseMetrics: 'Glucose Metrics',
    agp: 'AGP',
    dailyGlucose: 'Daily Glucose',
    sessionGlucose: 'Session Glucose',
    standTir: 'Standard TIR',
    customTir: 'Customized TIR',
    cancleGz: 'Unfollow',
    cancleText: 'Do you want to unfollow the current user?',
    helpCenterTip: 'Function not yet open'
  },
  //血糖报告
  glucoseReport: {
    statics: 'Statics',
    sixHour: "6 Hour's TIR",
    avgGlucose: 'Average Glucose',
    maxGlucose: 'Max Glucose',
    minGlucose: 'Min Glucose',
    cv: 'CV',
    high: 'Numbers of High',
    low: 'Numbers of Low',
    normal: 'Numbers of Normal',
    tir: 'TIR',
    estimatedA1c: 'Estimated A1c',
    min: 'Min',
    avg: 'Avg',
    max: 'Max',
    maxVariation: 'Max Variation'
  },
  //血糖档案
  glucoseProfile: {
    avg: 'Avg',
    sd: 'SD',
    cv: 'CV'
  },
  //事件列表
  eventList: {
    all: 'All',
    bg: 'BG',
    meal: 'Meal',
    sport: 'Sports',
    insulin: 'Insulin',
    alert: 'Alert',
    eventType: 'Event Type',
    description: 'Description',
    note: 'Note',
    highAlert: 'alert warning',
    calibration: 'Calibration',
    meds: 'Meds',
    time: 'Time',
    detail: 'Detail',
    weigt: 'Weight'
  },
  // 关注列表
  followerList: {
    title: 'Monitoring Users',
    tabTitle: 'Follower Management',
    refreshText:
      'Automatic refresh (user list automatically refreshes every 30 seconds)',
    addText: 'Add',
    dataText: 'Data obtained',
    timeText: 'minutes',
    hourText: 'hours',
    agoText: ' ago',
    tableEmail: 'Enter account number',
    searchPlacehold: 'Please enter your account number to search',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    addFollower: 'Add Follower',
    editFollower: 'Edit Follower',
    tableName: 'Name',
    tableAddTime: 'Add Time',
    tableStatus: 'Status',
    tableApproved: 'Approved',
    tableReject: 'Reject',
    tableStartSharing: 'Start Sharing',
    tableStopSharing: 'Stop Sharing',
    op: 'Operate',
    sharing: 'Sharing',
    notSharing: 'Not Sharing',
    tableRemove: 'remove',
    note: 'Note',
    message: 'Message',
    ruleMsgEmailEmpty: 'Please enter email to search',
    ruleMsgNote: 'Please enter note',
    ruleMsgMessage: 'Please leave a message',
    ruleMsgEmailCorrect: 'Please enter the correct email',
    formAcknowledge:
      'I acknowledge that adding follower will allow this user to see my data',
    sendFollowRequest: 'Send Follow Request',
    setNote: 'Set Note',
    tipsAcknowledge:
      'Please check the box, you acknowledge that adding follower will allow this user to see my data',
    stopSharing: 'Stop Sharing',
    startSharing: 'Start Sharing',
    removeUser: 'Remove User',
    confirmStopSharing: 'Are you sure to stop sharing glucose with this user?',
    confirmStartSharing:
      'Are you sure to start sharing glucose with this user?',
    confirmRemove: 'Are you sure to remove this user from the list?',
    approvedFollower: 'Approved Follower',
    rejectFollower: 'Reject Follower',
    confirmApproved: 'Are you sure to approve this follower request?',
    confirmReject: 'Are you sure to reject this follower request?',
    addTime: 'Add Time',
    check: 'Check',
    remove: 'Remove',
    removeUserTitle: 'Are you sure to remove this user from the list?'
  },
  //设置
  settings: {
    title: 'Glucose Level settings',
    unitSet: 'Unit Setting',
    targetSet: 'Customized TIR Setting',
    alertSet: 'Alert Setting',
    highAlert: 'High Alert',
    lowAlert: 'Low Alert',
    urgentLow: 'Urgent Low',
    urgentHigh: 'Urgent High',
    target: 'Target'
  },
  // pdf
  pdf: {
    dailyStatistics: 'Daily Statistics',
    title: 'AGP Report: Continuous Glucose Monitoring',
    page: 'Page',
    generated: 'Generated',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Time in Range',
    timeInRange: 'Time in Range (TIR) ',
    agpTitle: 'Ambulatory Glucose Profile （AGP）',
    agpSubTitle:
      'AGP is a summary of glucose values from the report period, with median (50%) and other percentiles shown as if they occurred in a single day',
    dailyTitle: 'Daily Glucose Profile',
    dailySubTitle:
      'Each daily profile represents a midnight-to-midnight period.',
    device: 'Device',
    tDevice: 'Terminal Device',
    print: 'Print',
    model: 'Model',
    deviceSn: 'Device SN',
    effectiveData: 'Effective Data',
    days: 'Days',
    appVer: 'App Version',
    smartPhoneModel: 'Smart Phone Model',
    osVersion: 'OS Version',
    appSetting: 'App Setting',
    GoalsforType1andType2Diabetes: 'Goals for Type 1 and Type 2 Diabetes',
    Each1timeinrange15minutes: 'Each 1% time in range =~15 minutes',
    note: 'Note: The % unit is applicable to the DCCT standard, and the mmol/mol unit is applicable to the IFCC standard.',
    DOB: 'DOB',
    SN: 'SN'
  },
  // 字段
  field: {
    timeCgmActive: 'Time CGM Active',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Avg. Calibration per day',
    glucoseAbility: 'Glucose Variability',
    lage: 'Lage',
    mage: 'Mage',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Calibration times'
  },
  agp: {
    agpTitle: 'Ambulatory Glucose Profile（AGP）',
    centerLine: 'Median',
    areaLine: 'Interval',
    target: 'Target range'
  },
  basic: {
    customTir: 'Custom TIR',
    bloodTip: 'Glucose reminder settings',
    bloodUnit: 'Glucose Unit',
    highTip: 'High Glucose Alert',
    lowTip: 'Low Glucose Alert',
    unitText: 'Automatically set based on country region',
    selectTip: 'Click on the icon to select or deselect the corresponding date',
    selectAll: 'Select All'
  },
  report: {
    threeMonth: 'Last 3 months',
    sixMonth: 'Nearly 6 months',
    yearText: 'Last year',
    showAll: 'Show All',
    all: 'All',
    selectDate: 'Select date range',
    to: 'to',
    startDt: 'Start Date',
    endDt: 'End Date',
    betaTest: 'Beta Testing',
    bloodData: 'Glucose data',
    userCount: 'User Account'
  },
  petDetail: {
    variety: 'Breed',
    type: 'Insulin type',
    freq: 'Insulin Freq.',
    lente: 'Lente',
    insulin: 'Insulin Glargine',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'AGP Report: Continuous Glucose Monitoring',
    snNumber: 'SN',
    page: 'Page',
    createTime: 'Generated',
    petInfo: 'Pet Information',
    petName: 'Pet Name',
    birthday: 'D.O.B',
    freq: 'Insulin Freq.',
    petType: 'Pet Type',
    age: 'Age',
    registerType: 'Syringe Type',
    basicBloodData: 'Glucose Metrics',
    dbText: 'Time in range（TIR）',
    target: 'Goals for Type 1 and Type 2  Diabetes',
    recordTime: 'Recording time',
    tag: 'tag',
    event: 'Event',
    eventDetail: 'Event Details',
    mulityText: 'Multi-day glucose trend chart',
    mulitySubText:
      'Multi-day glucose profiles represent the time interval of a device round',
    avageBlood: 'Average Glucose',
    bloodText: 'MODD',
    highTip: 'High Glucose Alert',
    lowTip: 'Low Glucose Alert',
    cat: 'Cat',
    dog: 'Dog',
    country: 'Country',
    insulinDose: 'Insulin Dose',
    weightUnit: 'kg'
  },

  eventDetail: {
    Empty: 'Empty',
    After_Breakfast: 'After Breakfast',
    Before_Lunch: 'Before Lunch',
    Breakfast: 'Breakfast',
    Lunch: 'Lunch',
    Dinner: 'Dinner',
    Before_Sleep: 'Before Sleep',
    Extra: 'Extra',
    Short_acting: 'Short-acting',
    Pre_mixed: 'Pre-mixed',
    Long_acting: 'Long-acting',
    Middle_acting: 'Middle acting',
    hour: 'h',
    minutes: 'min'
  }
};
export default en;
